export enum ImageOrientation {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical'
}

export default ImageOrientation;
